/* Checklist Operacional do Pesquisador — 4 grupos (V2 LSC/EGN). */
import { CHECKLIST_GROUPS } from "@/lib/constants";
import { Check } from "lucide-react";

export function checklistTotals(value) {
  let total = 0, done = 0;
  for (const g of CHECKLIST_GROUPS) {
    for (const it of g.items) {
      total += 1;
      if (value?.[g.key]?.[it.key]) done += 1;
    }
  }
  return { total, done };
}

export default function ChecklistOperacional({ value = {}, onChange, readOnly = false }) {
  const toggle = (groupKey, itemKey) => {
    if (readOnly) return;
    const next = { ...value, [groupKey]: { ...(value[groupKey] || {}), [itemKey]: !value?.[groupKey]?.[itemKey] } };
    onChange && onChange(next);
  };
  const { total, done } = checklistTotals(value);
  return (
    <div className="card-mil p-4" data-testid="checklist-operacional">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="label-mil text-[var(--gold)]">Checklist Operacional</div>
          <div className="font-display font-bold text-sm mt-0.5">do Pesquisador</div>
        </div>
        <div className="text-right">
          <div className="font-mono text-xl" style={{ color: done === total ? "var(--success)" : "var(--warn)" }} data-testid="checklist-progress">
            {done}/{total}
          </div>
          <div className="text-[10px] text-[var(--text-muted)] uppercase">concluído</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {CHECKLIST_GROUPS.map((g) => (
          <div key={g.key} className="border border-[var(--border)] rounded p-2">
            <div className="label-mil text-[var(--text-muted)] mb-1.5">{g.label}</div>
            <div className="space-y-1">
              {g.items.map((it) => {
                const checked = !!value?.[g.key]?.[it.key];
                return (
                  <button
                    key={it.key}
                    type="button"
                    onClick={() => toggle(g.key, it.key)}
                    disabled={readOnly}
                    aria-pressed={checked}
                    className={`flex items-center gap-2 text-xs w-full text-left p-1 rounded ${readOnly ? "cursor-default" : "cursor-pointer hover:bg-[var(--surface-2)]"}`}
                    data-testid={`check-${g.key}-${it.key}`}
                  >
                    <span className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 ${checked ? "bg-[var(--gold)] border-[var(--gold)]" : "border-[var(--border)]"}`}>
                      {checked && <Check size={10} className="text-black" strokeWidth={3} />}
                    </span>
                    <span className={checked ? "text-[var(--text)]" : "text-[var(--text-muted)]"}>{it.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
